export default __webpack_public_path__ + "static/media/016_photo.f4a2d312.jpg";